import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { InactiveIngredientAdminModel } from "../../../models/inactiveIngredient";
import { InputTextarea } from 'primereact/inputtextarea';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';


interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentInactiveIngredient: InactiveIngredientAdminModel
}

interface IState {
	inactiveIngredient: InactiveIngredientAdminModel,
	validationMessage: string,
	selectedLangId: number
}

class InactiveIngredientAddEditDialog extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {
			inactiveIngredient: props.currentInactiveIngredient,
			validationMessage: '',
			selectedLangId: Lang.bg
		};
	}

	handleChange = (key, value) => {
		const inactiveIngredient: InactiveIngredientAdminModel = { ...this.state.inactiveIngredient };
		inactiveIngredient[key] = value;
		this.setState({ inactiveIngredient: { ...inactiveIngredient } });
	};

	isValidAddEditForm() {
		let message = '';

		this.setState({
			validationMessage: ''
		});

		if (!this.state.inactiveIngredient.inactiveIngredientContent.some(r => r.name != null)) {
			message += "Please enter 'Name'.<br />";
		}

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = event => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const inactiveIngredient = { ...this.state.inactiveIngredient };

		this.props.saveClick(inactiveIngredient);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	onLangChange = (lang) => {
		this.setState({ selectedLangId: lang });
	}

	getValueContent = (key) => {
		let content = this.state.inactiveIngredient.inactiveIngredientContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	handleChangeContent = (key, value) => {
		const inactiveIngredient: InactiveIngredientAdminModel = { ...this.state.inactiveIngredient };
		let content = inactiveIngredient.inactiveIngredientContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ inactiveIngredient: { ...inactiveIngredient } });
	};

	public render() {

		const { inactiveIngredient, selectedLangId } = this.state;

		return (

			<Dialog header="Active Ingredient Form" responsive={true} width="70%"
				modal={true}
				visible={this.props.isVisible}
				onHide={this.handleCanselButton}
				footer={
					<div>
						<Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
						<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
					</div>}
			>
				<div style={{ minHeight: '250px', maxHeight: '350px' }}>

					{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
					<div className="p-grid p-fluid">
						<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						<div className="p-g-12 p-md-12">
							<label>Name:</label>
							<InputText
								name="name"
								onChange={(e) => this.handleChangeContent('name', e.target['value'])}
								value={this.getValueContent('name')}
							/>
						</div>
					</div>

				</div>
			</Dialog >
		)
	}
}

export default InactiveIngredientAddEditDialog;